import { TOGGLE_INVITE_TEAM_MODAL, TOGGLE_MANAGE_ROLES_MODAL } from "constants/actionTypes"

export const toggleInviteTeamModalVisible = () => ({
	type: TOGGLE_INVITE_TEAM_MODAL
})

export const toggleManageRolesModalVisible = () => ({
	type: TOGGLE_MANAGE_ROLES_MODAL
})
